
import { mapState, mapGetters } from 'vuex';
import ReviewSort from '@/enums/ReviewSort';
import { pathWithParams } from '@/lib/params';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import AiIconType from '@/enums/AiIconType';

export default {
  name: 'AppFilterSectionSearchBarPc',
  props: {
    params: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      selectedSortType: ReviewSort.RECENTLY_CREATED,
      searchInput: null,
      isMediaReviewsFirstChecked: false
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('review', ['hasMedia']),
    ...mapGetters('widget', ['displayMediaReviewsFirstToggleListV3']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    ReviewSort: () => ReviewSort,
    aiIconName() {
      return this.reviewSettings.ai_icon_type === AiIconType.CUSTOM
        ? 'icon-ai-solid'
        : 'icon-ai-gradation';
    },
    displayOrderOptions() {
      return this.widget.display_orders_in_use.map(order => ({
        value: order,
        name: ReviewSort.t(order),
        leadingAiIconName:
          order === ReviewSort.AI_RECOMMENDATION ? this.aiIconName : null
      }));
    },
    orderDescriptionMessage() {
      const messages = {};
      const mediaReviewsFirstMessage = this.isMediaReviewsFirst
        ? this.$t('search_bar.review_sort.message.media_reviews_first')
        : '';
      this.displayOrderOptions.forEach(orderOption => {
        const orderName = ReviewSort.key(orderOption.value);
        messages[orderOption.value] = this.$t(
          `search_bar.review_sort.message.${orderName}`,
          {
            media_reviews_first: mediaReviewsFirstMessage
          }
        );
      });
      return messages;
    },
    isMediaReviewsFirst() {
      return (
        this.isMediaReviewsFirstChecked || this.widget.review_show_photo_first
      );
    }
  },
  watch: {
    params(newParams, oldParams) {
      this.syncFilterStateFromParams();
      if (newParams.query !== oldParams.query) this.syncSearchStateFromParams();
    }
  },
  created() {
    this.syncFilterStateFromParams();
    this.syncSearchStateFromParams();
  },
  methods: {
    syncSearchStateFromParams() {
      this.searchInput = this.params.query || null;
    },
    syncFilterStateFromParams() {
      const { media_reviews_first, sort } = this.params;
      this.selectedSortType = parseInt(sort || this.widget.display_order);
      this.isMediaReviewsFirstChecked = media_reviews_first
        ? JSON.parse(media_reviews_first) || false
        : false;
    },
    submit(params) {
      this.$emit('submit', { ...params, page: '1' });
    },
    openReviewSortDialog() {
      const reviewSortPath = pathWithParams(
        `${window.location.origin}/v2/review_sort`,
        {
          display_orders_in_use: this.widget.display_orders_in_use,
          media_reviews_first: this.isMediaReviewsFirst
        }
      );
      this.windowService.openFullscreenPopup(reviewSortPath);
    },
    changeOrderOption(orderOption) {
      this.selectedSortType = orderOption;
      this.submit({ sort: this.selectedSortType });
    },
    enterSearchInput() {
      this.submitSearchInput();
      this.$nextTick(() => this.$refs.search_input.focus());
    },
    submitSearchInput() {
      this.submit({ query: this.searchInput });
    }
  }
};
